var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAndroidIconGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.588 18C.232 17.914 0 17.596 0 17.104V.874C0 .42.196.112.507 0l8.87 9.045L.586 18zm1.22-.345l10.676-5.44-2.6-2.652-8.076 8.092zm10.75-11.852L2.03.437l7.868 8.075 2.659-2.709zm.714.364l4.124 2.103c.78.398.788 1.04 0 1.44l-4.228 2.156-2.758-2.83 2.862-2.869z",
    fill: "currentColor",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAndroidIconGrey);
export default __webpack_public_path__ + "static/media/android_icon_grey.56fe62bf.svg";
export { ForwardRef as ReactComponent };